import styled from 'styled-components'
import { ScrollbarStyle } from '../../../styles/components/scrollbar'
import { theme } from '../../../styles/theme'

interface ITitleProps {
  hasGoTo: boolean;
}

export const Container = styled.div`
  width: 100vw;
  height: 100vh;

  overflow: hidden;
`

export const Main = styled.main`
  height: calc(100vh - 93px);
  margin-left: 93px;
  margin-top: 93px;

  overflow-y: auto;
  overflow-x: hidden;

  position: relative;

  ${ScrollbarStyle}

  @media (max-width: 650px) {
    margin-left: 0;
  }
`

export const Title = styled.h1<ITitleProps>`
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.large};
  line-height: ${theme.font.sizes.xlarge};
  color: ${theme.colors.brown};

  position: absolute;

  display: flex;
  align-items: center;

  cursor: ${({ hasGoTo }) => (hasGoTo ? 'pointer' : 'default')};

  top: 35px;
  left: 35px;
`
